import React from "react";
import PropTypes from "prop-types";

const ProductAvailabilityInfo = ({ productAvailabilityViews }) => {
    const productInfos = [];
    if(productAvailabilityViews) {
        productAvailabilityViews.forEach(p => productInfos.push(
            <div key={p.productName} className="product-availability-info">
                <p className="product-availability-product-name">
                    {p.productName}
                </p>
                {p.isAvailable ?
                    <p className="product-availability-info-status product-available">Available</p> :
                    <p className="product-availability-info-status product-maintenance">Maintenance</p>}

            </div>));
    }

    return (
        <div className="product-availability-list">
            <div className="product-availability-list-header">
                <i className="material-icons availability-icon">settings_ethernet</i>
                SoleSource Application Status
            </div>
            <p>Current status of all SoleSource applications:</p>
            {productInfos}
        </div>);
};

ProductAvailabilityInfo.propTypes = {
    productAvailabilityViews: PropTypes.array
};

export default ProductAvailabilityInfo;
